import React, { useState } from "react";
import { Row, Col, Button, Modal } from "antd";
import { EyeOutlined } from "@ant-design/icons";

const JsonViewerModal = ({ value }) => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [parsedData, setParsedData] = useState(null);

    const showModal = () => {
        try {
            const parsed = JSON.parse(value);
            setParsedData(parsed);
            setIsModalVisible(true);
        } catch (e) {
            // If parsing fails, show raw value
            setParsedData(value);
            setIsModalVisible(true);
        }
    };

    const handleClose = () => {
        setIsModalVisible(false);
    };

    const renderJsonContent = () => {
        const jsonString = typeof parsedData === 'object' && parsedData !== null
            ? JSON.stringify(parsedData, null, 2)
            : String(parsedData);

        return (
            <pre style={{
                backgroundColor: '#f5f5f5',
                padding: '16px',
                borderRadius: '4px',
                fontSize: '14px',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                margin: 0,
                maxHeight: '500px',
                overflow: 'auto'
            }}>
                {jsonString}
            </pre>
        );
    };

    return (
        <>
            <Button
                type="primary"
                size="small"
                icon={<EyeOutlined />}
                onClick={showModal}
            >
                View Data
            </Button>
            <Modal
                title="Additional Information"
                visible={isModalVisible}
                onCancel={handleClose}
                footer={[
                    <Button key="close" onClick={handleClose}>
                        Close
                    </Button>
                ]}
                width={700}
            >
                {renderJsonContent()}
            </Modal>
        </>
    );
};

const formatValue = (value, fieldName) => {
    // Only apply modal logic for additionalInfo field
    if (fieldName === 'info') {
        // Check if value is a string
        if (typeof value === 'string') {
            // Check if it's JSON
            if (value.trim().startsWith('{') || value.trim().startsWith('[')) {
                try {
                    JSON.parse(value); // Test if it's valid JSON
                    return <JsonViewerModal value={value} />;
                } catch (e) {
                    // If JSON parsing fails but string is long, still show in modal
                    if (value.length > 20) {
                        return <JsonViewerModal value={value} />;
                    }
                    return value;
                }
            }
            // Check if string is longer than 20 characters
            if (value.length > 20) {
                return <JsonViewerModal value={value} />;
            }
        }
    }
    return value;
};

const showCardInfo = (fields, labelSpan = 10, valueSpan = 14) => (
    <div className="details-info--text">
        {fields.map(({ name, label, value },idx) => (
            <Row gutter={[0, 8]} key={`name-${idx}`}>
                <Col key={`label-${name}-${idx}`} span={labelSpan}>
                    <span className="text">
                        <b>{label}</b>
                    </span>
                </Col>
                <Col key={`value-${name}-${idx}`} span={valueSpan}>
                    <span className="text">{formatValue(value, name)}</span>
                </Col>
            </Row>
        ))}
    </div>
);

export default showCardInfo;